function startOfLine(source: string, offset: number) {
  return source.slice(0, offset).lastIndexOf('\n') + 1
}

function endOfLine(source: string, offset: number) {
  const end = source.indexOf('\n', offset)
  return end === -1 ? source.length : end
}

/** Get the start and end of the line that contains this offset. Does not include the `\n` at the end of the line. */
export function getLineRange(source: string, offset: number) {
  if (offset < 0 || offset > source.length) return null
  return {start: startOfLine(source, offset), end: endOfLine(source, offset)}
}

/** Get the start and ends of each line that overlaps the range. */
export function getLineRanges(source: string, from: number, to: number) {
  const ranges = []
  let start = startOfLine(source, from)
  while (start <= to) {
    const end = endOfLine(source, start)
    ranges.push({start, end})
    start = end + 1
  }
  return ranges
}
